import {Alert, Box, Button, Container, Icon, List, ListItem, Stack, Typography} from "@mui/material";
import {SmsCampaignService, SmsPackageDto} from "../../../api/psc";
import {DialogContainer, DialogHeader, PageHeader, Spinner} from "../../../components/exports";
import useDynamicList from "../../../hooks/UseDynamicList";
import SmsPackageItem from "../components/SmsPackageItem";
import Blog from "../components/Blog";
import {useContext} from "react";
import {DialogContext} from "../../../contexts/DialogueContext";

export default function Store() {
    const manager = useDynamicList<SmsPackageDto>(async (offset) => {
        return SmsCampaignService.listSmsPackages("1");
    });
    const dialog = useContext(DialogContext);

    if (manager.requestInProgress) {
        return <Spinner/>;
    }

    const loadDialog = () => {
        dialog.openDialog(
            <DialogContainer preferredWith={800}>
                <DialogHeader title="ارزش افزوده سرویس پیامک پرشین سازه چیست؟"/>
                <Box sx={{p: 2, height: '80dvh'}}>
                    <Blog/>
                </Box>
            </DialogContainer>
        )
    }

    return (
        <Container maxWidth="sm" sx={{
            display: 'flex',
            flexDirection: {xs: 'column', md: 'row'},
            justifyContent: "space-between",
            gap: 5
        }}>
            <Box sx={{flex: 1}}>
                <PageHeader
                    title="لیست پکیج‌های پیامک تبلیغاتی"
                />

                <Stack spacing={2}>

                    <Button variant='contained' color='purple' size='large' startIcon={<Icon>touch_app</Icon>}
                            onClick={loadDialog}>ارزش افزوده سرویس پیامک پرشین سازه چیست؟</Button>

                    {manager.results
                        .filter((p) => !p.addPrivateGatewayNumbers)
                        .map((p) => (
                            <SmsPackageItem item={p} key={p.id}/>
                        ))}
                </Stack>

                <PageHeader title="لیست پکیج‌های پیامک خدماتی"/>

                <Alert severity="info" sx={{mb: 2}} variant="filled">
                    با خرید این پکیج ها، سرشماره اختصاصی به مدت یک ماه برای شما فعال
                    میشود. امکان بارگذاری شماره به صورت دستی وجود ندارد،
                </Alert>

                <Stack spacing={2}>
                    {manager.results
                        .filter((p) => p.addPrivateGatewayNumbers)
                        .map((p) => (
                            <SmsPackageItem item={p} key={p.id}/>
                        ))}
                </Stack>
            </Box>
        </Container>
    );
}
